import React from 'react'
import Button from '../Button/Button'
import Card from '../Card/Card'
import './CardWrapper.css'

const CardWrapper = (props) => {
  return (
    <div data-aos="fade-up" data-aos-duration="300" data-aos-offset="100" className='card_wrapper' >
      <div>
        <Card src={props.src} title={props.title} subtitle={props.subtitle} />
      </div>
      <div className='button_wrapper'>
        <div><Button label="Visit"  link={props.vlink}/></div>
        <div><Button label="Github" link={props.glink}/></div>
      </div>
    </div>
  );
}

export default CardWrapper